document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.getElementById('load-more-button');
    const productList = document.getElementById('product-list-{{ section.id }}');
    const collectionHandle = '{{ collection.handle }}';

    if (loadMoreButton && productList) {
        loadMoreButton.addEventListener('click', function() {
            const nextPage = loadMoreButton.dataset.nextPage;

            fetch(`/collections/<span class="math-inline">\{collectionHandle\}?page\=</span>{nextPage}&view=ajax`)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;

                    const newProducts = tempDiv.querySelectorAll('.product-card');
                    newProducts.forEach(product => {
                        productList.appendChild(product);
                    });

                    const currentPage = parseInt(nextPage);
                    loadMoreButton.dataset.nextPage = currentPage + 1;

                    fetch(`/collections/<span class="math-inline">\{collectionHandle\}?page\=</span>{currentPage + 1}&view=ajax`)
                    .then(response => response.text())
                    .then(data2 => {
                        const checktempDiv = document.createElement('div');
                        checktempDiv.innerHTML = data2;
                        const checknewProducts = checktempDiv.querySelectorAll('.product-card');
                        if (checknewProducts.length === 0){
                          loadMoreButton.style.display = 'none';
                        }
                    })
                    .catch(error => console.error('Error checking next page:', error));

                })
                .catch(error => console.error('Error loading more products:', error));
        });
    }
});